<script setup lang="ts">
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'

const route = useRoute()
const isMapOverlay = computed(() => Boolean(route.meta.mapOverlay))
const isInteractiveMapOverlay = computed(() => Boolean(route.meta.mapInteractiveOverlay))
const shouldInertMap = computed(() => isMapOverlay.value && !isInteractiveMapOverlay.value)
const transitionName = computed(() => (isMapOverlay.value ? '' : 'route-overlay-back'))
</script>

<template>
  <div
    class="persistent-map-view"
    :aria-hidden="shouldInertMap ? 'true' : undefined"
    :inert="shouldInertMap ? true : undefined"
  >
    <RouterView />
  </div>
  <RouterView v-slot="{ Component }" name="overlay">
    <Transition :name="transitionName">
      <div v-if="Component" class="route-overlay-surface">
        <component :is="Component" />
      </div>
    </Transition>
  </RouterView>
</template>

<style>
.persistent-map-view {
  width: 100%;
  height: 100%;
}

.route-overlay-surface,
.route-overlay-back-leave-active {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 60;
  backface-visibility: hidden;
}

.route-overlay-back-leave-to {
  transform: translate3d(100%, 0, 0);
  opacity: 0;
}

.route-overlay-back-leave-active {
  will-change: transform, opacity;
  transition:
    transform 300ms cubic-bezier(0.4, 0, 0.2, 1),
    opacity 300ms ease-out;
}

@media (prefers-reduced-motion: reduce) {
  .route-overlay-back-leave-active {
    transition-duration: 1ms;
  }

  .route-overlay-back-leave-to {
    transform: none;
    opacity: 0;
  }
}
</style>
